import {
  Box, Button, Input, Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useDisclosure,
} from "@chakra-ui/react";
import { useReducer } from "react";
import { useAuth } from "../../../Hooks/useAuth";
import { api } from "../../../services/api";
import swal from "sweetalert";

const GREEN  = "#004a33";
const ORANGE = "#fc8f04";

function FormField({ label, children }) {
  return (
    <Box mb="14px">
      <Text fontSize="11px" fontWeight="700" color="gray.500" mb="5px" textTransform="uppercase" letterSpacing="0.05em">
        {label}
      </Text>
      {children}
    </Box>
  );
}

const inputProps = {
  borderRadius: "8px",
  fontSize: "14px",
  bg: "white",
  border: "1px solid rgba(0,74,51,.2)",
  _focus: { borderColor: GREEN, boxShadow: `0 0 0 1px ${GREEN}` },
};

export function EditSubcategory({ subcategoryId, onUpdateSubcategory }) {
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [subcategory, setSubcategory] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { name: "" }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubcategory({ [name]: value });
  };

  async function handleSave(e) {
    e.preventDefault();
    const formData = new FormData();
    formData.append("subcategory[name]", subcategory.name);
    const response = await api.put(`/api/v1/subcategories/${subcategoryId}`, formData, {
      headers: { "access-token": user.token, client: user.client, uid: user.uid, accept: "application/json", contentType: "multipart/form-data" },
    });
    if (response.status === 200) {
      onUpdateSubcategory(subcategoryId, response.data.name);
      swal({ title: "Atualizado!", text: "Subcategoria atualizada com sucesso.", icon: "success" });
      onClose();
    } else {
      swal({ title: "Erro", text: "Algo deu errado.", icon: "error" });
      onClose();
    }
  }

  return (
    <>
      <Button
        size="xs" borderRadius="7px" px="10px" h="26px"
        bg={GREEN} color={ORANGE} fontWeight="700" fontSize="11px"
        _hover={{ opacity: 0.85 }} onClick={onOpen}
      >
        Editar
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="rgba(0,0,0,.45)" backdropFilter="blur(2px)" />
        <ModalContent borderRadius="16px" overflow="hidden" mx="16px">
          <ModalHeader bg={GREEN} py="14px" px="20px" pr="44px">
            <Text fontSize="15px" fontWeight="800" color={ORANGE}>Editar Subcategoria</Text>
            <Text fontSize="11px" color="rgba(255,255,255,.45)" fontWeight="500" mt="1px">#{subcategoryId}</Text>
          </ModalHeader>
          <ModalCloseButton color="rgba(255,255,255,.6)" _hover={{ color: "white", bg: "transparent" }} top="12px" right="14px" />
          <ModalBody px="20px" py="20px" bg="#fafbfc">
            <FormField label="Nome">
              <Input placeholder="Novo nome da subcategoria" name="name" onChange={handleChange} {...inputProps} />
            </FormField>
          </ModalBody>
          <ModalFooter bg="white" borderTop="1px solid rgba(0,74,51,.08)" px="20px" py="12px" gap="8px" justifyContent="flex-end">
            <Button size="sm" variant="ghost" colorScheme="gray" borderRadius="8px" onClick={onClose}>Cancelar</Button>
            <Button size="sm" bg={GREEN} color={ORANGE} borderRadius="8px" px="16px" fontWeight="700" fontSize="12px" _hover={{ opacity: 0.88 }} onClick={handleSave}>
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
